import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["putData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "CREATE_ORDER_FOB_" }
);

export interface CreateOrderFOBState extends IState {}

const INITIAL_STATE: CreateOrderFOBState = {
  loading: false,
  error: null,
};

const request = (state: CreateOrderFOBState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: CreateOrderFOBState) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: CreateOrderFOBState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const createOrderFOB = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const CreateOrderFOBTypes = Types;
export const CreateOrderFOBActions = Creators;
